import type { ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

const model = {
  createBraintreeClientToken: String,
} satisfies ModelDefinition;

export const CreateBraintreeClientTokenModel = createModel({
  data: model,
}).transform(
  {
    braintreeClientToken: String,
  },
  (data) => ({ braintreeClientToken: data.data.createBraintreeClientToken }),
);
